import { apiAuth, apiResponseType } from ".";

export const createAbsence = (data) =>
  apiAuth.postForm("/absences/store", data) as apiResponseType;

export const getMyAbsences = (page: number = 1): apiResponseType =>
  apiAuth.get(`absences/my-requests?page=${page}`);

export const getMyPendingAbsenceApprovals = (page: number = 1): apiResponseType =>
  apiAuth.get(`absences/my-pending-approvals?page=${page}`);

export const getAbsencesData = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `absences?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}${
      name ? `&name=${encodeURIComponent(name)}` : ""
    }`
  );

export const getPendingAbsencesForReview = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `absences/pending-for-review?page=${page}${
      unity_id ? `&unity_id=${unity_id}` : ""
    }${name ? `&name=${encodeURIComponent(name)}` : ""}`
  );

export const getShowAbsence = (uuid: string) =>
  apiAuth.get(`absences/${uuid}/show`) as apiResponseType;

export const approveAbsence = (uuid: string, note?: string) =>
  apiAuth.put(`absences/${uuid}/approve`, { note }) as apiResponseType;

export const rejectAbsence = (uuid: string, note: string) =>
  apiAuth.put(`absences/${uuid}/reject`, { note }) as apiResponseType;

export const cancelAbsence = (uuid: string, note: string) =>
  apiAuth.put(`absences/${uuid}/cancel`, { note }) as apiResponseType;

export const getVacationCalendar = (
  year: number,
  filters?: { name?: string; unity_id?: string; sector_id?: number }
): apiResponseType =>
  apiAuth.get(`absences/vacation-calendar`, {
    params: { year, ...filters },
  }) as apiResponseType;
